/**
 * created by wang lei
 继承编辑器-添加跳转链接 页面
 *
 */
import React, {Component} from 'react';
import EditorInformation from "../../components/EditorInformation";
import {Row} from "antd";

export class EditorInformationOfWebEditor extends EditorInformation {
    renderEditorInformation = () => {
        const { informationStatus} = this.props;
        return (
            <div style={{display: informationStatus ? '' : 'none'}}>
                {/*副标题等*/}
                {this.renderFTitle()}
                {/*动态渲染的表单*/}
                <Row gutter={24}>
                    {this.renderDynamicForm()}
                    {this.renderSourceDeptNameField()}
                </Row>
                {/*标签*/}
                {this.renderLabel()}
                {/*站群扩展字段*/}
                <Row gutter={24}>{this.renderColumnExtendField()}</Row>
                {/*跳转链接*/}
                {this.renderMipLink()}
                {/*上传附件*/}
                {this.renderUpload()}
                {/*附件列表*/}
                {this.renderAttach()}
            </div>
        )
    };
}